// These are used for displaying Vote types in the drop-down
export enum VoteTypes {
  BQ = "BQ",
  MQ = "MQ",
  FADE = "Fade",
  FULL_VOTE = "Full Vote"
}

export const FACTOR_TO_VOTE_TYPE_MAP: Record<FactorShortName, VoteTypes> = {
  BQ: VoteTypes.BQ,
  MQ: VoteTypes.MQ,
  FADE: VoteTypes.FADE,
}

export const voteTypeOptions = Object.values(VoteTypes).map(value => ({ value }));